'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _exenv = require('exenv');

exports['default'] = {
  getSize: function getSize() {
    return {
      width: _exenv.canUseDOM && (window.innerWidth || document.body.clientWidth) || 1024,
      height: _exenv.canUseDOM && (window.innerHeight || document.body.clientHeight) || 768
    };
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lib/components/helpers/screen.js
// module id = 328
// module chunks = 0